import React from 'react';
import styles from './search-bar.module.scss';

interface SearchBarProps {
  placeholder?: string;
  searchValue: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch?: () => void;
  className?: string;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  onClearSearch?: () => void;
  disabled?: boolean
  classNameInput?: string;
  searchFieldIcon?: string
}

const SearchBar: React.FC<SearchBarProps> = ({searchFieldIcon, placeholder, searchValue, onSearchChange, onSearch, onClearSearch, className = '', inputProps = {}, disabled, classNameInput = '' }) => {
  const searchBarClass = `${styles.searchBar} ${searchValue ? styles.active : ''} ${disabled ? styles.disabled : ''} ${className}`;

  const handleSearchClick = () => {
    if (onSearch) {
      onSearch();
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearchClick();
    }
  };

  return (
    <div className={searchBarClass}>
      <input
        type="text"
        placeholder={placeholder}
        className={`${styles.searchInput} ${classNameInput}`}
        onChange={onSearchChange}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        value={searchValue}
        {...inputProps}
      />
      {searchValue ? (
        <button className={styles.searchButton} onClick={onClearSearch}>
          <div className={`${styles.iconClear} ${searchFieldIcon && searchFieldIcon}`} />
        </button>
      ) : (
        <button className={styles.searchButton} onClick={handleSearchClick}>
          <div className={`${styles.iconSearch} ${searchFieldIcon && searchFieldIcon}`}/>
        </button>
      )}
    </div>
  );
};

export default SearchBar;





